module.exports = __webpack_public_path__ + "assets/img/blindBoxRecord.e18f0344.png";